export default "__VITE_ASSET__IqjM0Q5I__";